import React from "react";

import {Snackbar,Alert} from '@mui/material';


const GlobalSnackbar = (props) => {
    const { openSnack, handleCloseSnack,severity,messaggio } = props;




return (
    <>
    <Snackbar open={openSnack} autoHideDuration={5000} style={{marginTop:"50px"}} anchorOrigin={{vertical:"top",horizontal: "right" }} onClose={handleCloseSnack}>
        <Alert onClose={handleCloseSnack} severity={severity} sx={{ width: '100%' }}  variant="filled">
     {messaggio}
        </Alert>
      </Snackbar>
      </>
)


}

export default GlobalSnackbar;


/*
Da usare :
variabili da dichiarare per lo snack -> const [openSnack, setOpenSnack] = useState(false);
const handleCloseSnack = (event, reason) => {
  if (reason === 'clickaway') {
    return;
  }
  setOpenSnack(false);
}
const [snack,setSnack] = useState({severity:"success",messaggio:"Salvataggio Effettuato correttamente",open:false});

funzioni per aprire e modificare messaggio / severity -> setSnack({severity:"success",messaggio:"Cliente creato con successo"}) ;setOpenSnack(true);

il componente ->  <GlobalSnackbar severity={snack.severity} messaggio={snack.messaggio} openSnack={openSnack} handleCloseSnack={handleCloseSnack}/>

*/